import { storyblokEditable, type SbBlokData } from '@storyblok/js';
import { isStoryblokInspectorEnabled } from '../utils/inspector';

const SPACE_ID = '301263';
const EDIT_LINK_PREFIX = 'sbEditLink';

export default defineNuxtPlugin((nuxtApp) => {
  if (!(isInStoryblokVisualEditor() || isStoryblokInspectorEnabled())) {
    return;
  }

  const getStoryblokConfig = (blok: SbBlokData) => {
    try {
      return JSON.parse(storyblokEditable(blok)?.['data-blok-c'] as string);
    } catch {
      return {};
    }
  };

  useHead({
    style: [
      {
        innerHTML: `
          [data-sb-id] {
            outline: 1px dashed #aaa;
          }

          .sb-edit-link {
            position: absolute;
            color: #fff;
            border: none;
            font-size: 12px;
            border-radius: 4px;
            cursor: pointer;
            z-index: 50;
            padding: 4px 8px;
            background-color: #00b3b0;
            top: anchor(top);
            right: anchor(right);
          }
        `,
      },
    ],
  });

  nuxtApp.vueApp.directive('editable', {
    mounted(el, binding) {
      const { id, uid, name } = getStoryblokConfig(binding?.value);
      const idParent = new URLSearchParams(window.location.search).get('_storyblok');

      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- this package doesn't depend on @nuxtjs/i18n, so $i18n isn't typed on NuxtApp here; it's only present at runtime via consuming apps
      const locale = (useNuxtApp() as any).$i18n.locale.value?.replace('formal', 'fm');

      if (id && uid) {
        const sbId = `${id}-${uid}-${crypto.randomUUID()}`;
        el.setAttribute('data-sb-id', sbId);

        const anchorName = `--storyblok-${sbId}`;
        el.style.anchorName = anchorName;

        const editLink = document.createElement('a');
        editLink.classList.add('sb-edit-link');
        editLink.id = `${EDIT_LINK_PREFIX}-${sbId}`;
        editLink.textContent = isInStoryblokVisualEditor() && idParent !== id ? `Edit ${name} ⤴️` : `Edit ${name}`;
        editLink.target = isInStoryblokVisualEditor() && idParent === id ? '_parent' : '_blank';
        editLink.href = `https://app.storyblok.com/#/me/spaces/${SPACE_ID}/stories/0/0/${id}/blok/${uid}?lang=${locale}`;
        editLink.style.setProperty('position-anchor', anchorName);

        document.body.appendChild(editLink);
      }
    },
    unmounted(el) {
      const sbId = el.getAttribute('data-sb-id');
      const editLink = document.getElementById(`${EDIT_LINK_PREFIX}-${sbId}`);
      editLink?.remove();
    },
  });
});
